import React from "react";

import { TextField, CardActions, Button, FontIcon, CardText } from "react-md";
import RegistrationCard from "../RegistrationCard";
import CenteredSection from "../../../common/components/CenteredSection";
import { normalizeEmail } from "../../../common/normalize";

export default class StartPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      email: "",
    };

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleFormChange(value, event) {
    const normalizedValue =
      event.target.name === "email" ? normalizeEmail(value) : value;

    this.setState({
      [event.target.name]: normalizedValue,
    });

    this.validate();
  }

  validate() {
    const emailInput = document.getElementById("email");
    const isInvalid = !emailInput.validity.valid;
    this.setState({ isValid: !isInvalid });
  }

  handleSubmit() {
    // this.props.onSubmit(this.state.email);

    this.props.submit({
      email: this.state.email,
    });
  }

  render() {
    return (
      <CenteredSection size={6} offset={3}>
        <RegistrationCard
          title="Welcome to Orlando Gun Club!"
          subtitle="Begin by entering your email address."
        >
          <section className="md-grid">
            <TextField
              label="Enter your email address"
              id="email"
              name="email"
              type="email"
              className="md-cell md-cell--12"
              leftIcon={<FontIcon>email</FontIcon>}
              onChange={this.handleFormChange}
              error={!!this.state.email && !this.state.isValid}
              errorText="Please enter a valid email address"
              required
              pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
              value={this.state.email || ""}
            />
          </section>
          <CardActions>
            <Button
              raised
              label="Begin"
              className="md-cell--right"
              primary
              disabled={!this.state.isValid}
              onClick={() =>
                this.props.onSubmit({
                  email: this.state.email,
                  location: this.props.selectedLocation,
                })
              }
            />
          </CardActions>
        </RegistrationCard>
      </CenteredSection>
    );
  }
}



// WEBPACK FOOTER //
// ./src/registration/components/Start/StartPage.jsx